module.exports = __webpack_public_path__ + "assets/img/footer_floor.3f6f9cd4.svg";